// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"AdministrateUserModal_buttonContainer__3r0Ai","button":"AdministrateUserModal_button__1bu-x"};